// src/graphql/blog.queries.ts
import { gql } from "@apollo/client";

export const GET_ALL_BLOGS = gql`
  query GetAllBlogs($path: String!, $pageSize: Int!, $after: String) {
    search(
      first: $pageSize
      after: $after
      where: { AND: [{ name: "_path", value: $path, operator: CONTAINS }] }
      orderBy: { name: "Published Date", direction: DESC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        id
        path
        TitleRichText: field(name: "TitleRichText") {
          value
        }
        BlogImage: field(name: "Blog Image") {
          value
        }
        LastUpdated: field(name: "Last Updated") {
          value
        }
        PublishedDate: field(name: "Published Date") {
          value
        }
      }
    }
  }
`;

export const GET_FILTERED_BLOGS = gql`
  query GetFilteredBlogs(
    $path: String!
    $searchValue: String!
    $pageSize: Int!
    $after: String
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          {
            OR: [
              { name: "TitleRichText", value: $searchValue, operator: CONTAINS }
              { name: "BodyRichText", value: $searchValue, operator: CONTAINS }
            ]
          }
        ]
      }
      orderBy: { name: "Published Date", direction: DESC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        id
        path
        TitleRichText: field(name: "TitleRichText") {
          value
        }
        BodyRichText: field(name: "BodyRichText") {
          value
        }
        BlogImage: field(name: "Blog Image") {
          value
        }
        LastUpdated: field(name: "Last Updated") {
          value
        }
        PublishedDate: field(name: "Published Date") {
          value
        }
      }
    }
  }
`;
